import React, { useEffect, useRef } from 'react';
import './navigationDrawer.scss';

function NavigationDrawer(props) {
  const { dialogClassName, open } = props;
  const mySidenavRef = useRef();
  const backdropRef = useRef();

  if (open) {
    document.querySelector("body").style.overflow = "hidden";
    document.querySelector("html").style.overflow = "hidden";
  } else {
    document.querySelector("body").style.overflow = "auto";
    document.querySelector("html").style.overflow = "auto";
  }

  useEffect(() => {
    if (mySidenavRef) {
      mySidenavRef.current.style.width = '100vw';
   }
  
   if (backdropRef) {
      backdropRef.current.style.display = 'block';
    }
    return () => {
      if (mySidenavRef) {
        mySidenavRef.current.style.width = 0;
        document.querySelector("body").style.overflow = "auto";
        document.querySelector("html").style.overflow = "auto";
      }
      if (backdropRef) {
       backdropRef.current.style.display = 'none';
       document.querySelector("body").style.overflow = "auto";
       document.querySelector("html").style.overflow = "auto";
      }
    };
  }, [open]);

  return (
    <>
      <div
        ref={mySidenavRef}
        className={`navigation-drawer-sidenav ${dialogClassName}`}
        id="mySidenav"
      >
        {props.children}
      </div>
      <div ref={backdropRef} className="backdrop-container" id="navigation-drawer-backdrop"></div>
    </>
  );
}

export default NavigationDrawer;
